export function reducer(state, action) {
  switch (action.type) {
    case "SET_RENEWAL_FIELD_COUNT": {
      return {
        ...state,
        renewalFieldsCount: action.payload,
      };
    }
    case "SUBMIT_METRIC_FORM": {
      return {
        ...state,
        isMetricFormSubmitted: action.payload,
      };
    }
    case "SUBMIT_CALC_FORM": {
      return {
        ...state,
        isCalcFormSubmitted: action.payload,
      };
    }

    case "TRIGGER_CALC_FORM_VALIDATION": {
      return {
        ...state,
        isCalcFormValidationTriggered: action.payload,
      };
    }
    case "SET_SHOW_GRATITUDE_MODAL": {
      return {
        ...state,
        showGratitudeModal: action.payload,
      };
    }
    case "SET_CALC_FORM_DATA": {
      return {
        ...state,
        calcFormData: action.payload,
      };
    }

    case "SUBMIT_GRATITUDE_MODAL": {
      return {
        ...state,
        isGratitudeModalSubmitted: action.payload,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
